(function() {
    'use strict';

    angular.module( APP_ID )
        .directive( 'collapsible', [ '$compile', '$window', '$timeout', 'TEXTS', 'CONFIG', CollapsibleDirective ]);


    /**
     * Makes any content block collapsible/expandable.
     *
     * @attribute {boolean}  mobile-only ~ If true, it makes the content expandable on mobile devices *ONLY*.
     * @attribute {boolean}  collapsing-condition ~ Whether or not the content
     * should be collapsed (eg. {{ list.length > 12 }} will show this
     * list for list with more than 12 items).
     * @attribute {string}  show-more-label ~ HTML String that allows to
     * override label of the 'show more' button/link.
     * @attribute {string}  show-more-title ~ Allows to override link title of
     * the 'show more' button/link.
     * @attribute {string}  show-more-label ~ Allows to specify CSS class of
     * the 'show more' button/link.
     * @attribute {string}  show-less-label ~ HTML String thta allows to
     * override label of the 'show less' button/link.
     * @attribute {string}  show-less-title ~ Allows to override link title of
     * the 'show less' button/link.
     * @attribute {string}  show-less-label ~ Allows to specify CSS class of
     * the 'show less' button/link.
     * @attribute {string}  min-rows        ~ Number of rows within the
     * content's structure that should remain visible after collapsing
     * (Default: 0).
     *
     * @param {any} $compile
     * @param {any} $window
     * @param {$timeout} $timeout
     * @param {Object} TEXTS
     * @param {Object} CONFIG
     *
     * @type {ng.IDirectiveCompileFn}
     */
    function CollapsibleDirective(
        $compile,
        $window,
        $timeout,
        TEXTS,
        CONFIG
    ){





        /* ===== PRIVATE MEMBERS ============================================ */


        /** @constant */
        var COLLAPSIBLE_CONTENT_CLASS = 'collapsible',
        COLLAPSIBLE_PARENT_CLASS      = 'collapsible-wrapper',


        DEFAULTS = {
            SHOW_MORE_LABEL:     TEXTS.GENERIC.COLLAPSIFY.LINK_SHOW_MORE_LABEL,
            SHOW_MORE_TITLE:     TEXTS.GENERIC.COLLAPSIFY.LINK_SHOW_MORE_TITLE,
            SHOW_MORE_CLASS:     null,

            SHOW_LESS_LABEL:     TEXTS.GENERIC.COLLAPSIFY.LINK_SHOW_LESS_LABEL,
            SHOW_LESS_TITLE:     TEXTS.GENERIC.COLLAPSIFY.LINK_SHOW_LESS_TITLE,
            SHOW_LESS_CLASS:     null,

            MIN_ROWS:            '0',
            COLLAPSING_CONDITION:'true'
        };


        /** @type {ng.IDirective} */
        var directiveConfig = {
            restrict:   'EA',
            link:       link
        };



        ////////////////////////////////////////////////////////////////////////

        return directiveConfig;

        ////////////////////////////////////////////////////////////////////////



        /**
         * @param {ng.IScope} $scope
         * @param {ng.IElement} collapsibleBlockElement
         * @param {ng.IAttributes} attrs
         */
        function link(
            $scope,
            collapsibleBlockElement,
            attrs
        ){





            /* ===== EXPOSE TO THE SCOPE ==================================== */


            // Members
            $scope.isCollapsed = true;

            // Methods
            $scope.toggle      = toggle;





            /* ===== PRIVATE MEMBERS ======================================== */


            /** @type {boolean} */
            var isMobileOnly, collapsingCondition;


            /** @type {string} */
            var showMoreLabel, showMoreTitle, showMoreClass,
            showLessLabel, showLessTitle, showLessClass;


            /** @type {number} */
            var minHeight, maxHeight, minRows;


            /** @type {Math} */
            var math = $window.Math;


            /** @type {ng.IController} */
            var parentalController;


            /** @type {DOMElement} */
            var controlsTemplate, controlsElement = null,
            parentBlockElement;





            /* ===== RUN ON INSTANTIATION =================================== */


            /** @constructor */
            (function init(){
                parentalController = findParentsController();

                initAttributes();
                parentalControllerInjection();

                if ( collapsingCondition !== 'true' || ( isMobileOnly && !isMobile() ) ) {
                    parentalController.collapserInitialisationsList.push( function(){} );
                    return;
                };

                enhanceDOM();

                parentalController.collapserInitialisationsList.push( calculateSizingAndInvalidate );
            })();


            /** @destructor */
            (function destroy(){
                collapsibleBlockElement.on( '$destroy', function () {
                    if ( controlsElement ){
                        controlsElement.remove();
                        controlsElement = null;
                    }
                });
            })();





            /* ===== PRIVATE FUNCTIONS ====================================== */


            function findParentsController() {
                var currentParent = $scope;

                while ( currentParent ) {
                    if ( currentParent.hasOwnProperty( 'vm' ) ) return currentParent.vm;
                    currentParent = currentParent.$parent;
                }

                return null;
            }


            function parentalControllerInjection() {
                if ( !parentalController ) return;

                if ( !parentalController.hasOwnProperty( 'collapserInitialisationsList' ) ) {
                    // First run
                    parentalController.collapserInitialisationsList = [];

                    parentalController.externalPostLink = function() {
                        /** Measures and invalidates collapsifiers after they're added to the DOM. */
                        parentalController.collapserInitialisationsList.forEach( function( collapserInitialisationFn ) {
                            if ( collapserInitialisationFn ) collapserInitialisationFn();
                        });
                    }
                }
            }


            /**
             * Function that should be run *AFTER* all the items were bound
             * to the DOM, initialised and drawn (e.g. in the parent's
             * `link()` or inside `$timeout()` functions).
             *
             * If elements selectors are not specified in {configObject},
             * direct children are assumed for container and its elements.
             *
             * @param {{itemsContainerSelector: string, itemsSelector: string}} configObject
              */
            function calculateSizingAndInvalidate( configObject ) {
                // Element selectors
                var itemsContainerElementSelector = ( configObject && configObject.hasOwnProperty( 'itemsContainerSelector' ) ) ? configObject.itemsContainerSelector : '',

                itemsElementsSelector = ( configObject && configObject.hasOwnProperty( 'itemsSelector' ) ) ? configObject.itemsSelector : '';

                // Elements
                var itemsContainerElement = angular.element( collapsibleBlockElement.children( itemsContainerElementSelector )[ 0 ] ),
                itemElements = itemsContainerElement.children( itemsElementsSelector ),
                itemElement = angular.element( itemElements[ 0 ] ),

                // Calculating sizing
                itemsColumnCount    = math.floor( math.floor( itemsContainerElement.width()) / math.floor( itemElement.width() )),
                itemsRowMinsSum     = 0,
                totalItemsHeightSum = 0;

                itemElements.each( function( index ) {
                    totalItemsHeightSum += angular.element( this ).outerHeight( true );

                    if ( index < minRows ) {
                        itemsRowMinsSum += angular.element( this ).outerHeight( true );
                    }
                });

                //TODO: (!) Improve
                minHeight = attrs.hasOwnProperty( 'minHeight' ) ? attrs[ 'minHeight' ] : itemsRowMinsSum;


                if ( attrs.hasOwnProperty( 'maxHeight' ) ) {
                    maxHeight = attrs[ 'maxHeight' ];
                } else {
                    maxHeight = totalItemsHeightSum / itemsColumnCount;

                    if ( itemsColumnCount > 1 ) {
                        maxHeight += itemsColumnCount * 8; // Safety offset
                    }
                }

                // Applying collapsifier
                itemsContainerElement.height( maxHeight );
                invalidate();
            }


            function enhanceDOM() {
                // Compile templates
                initTemplates();

                controlsElement = $compile( controlsTemplate )( $scope )
                collapsibleBlockElement.after( controlsElement );

                collapsibleBlockElement.height( 0 );

                // Add classes
                collapsibleBlockElement.addClass( COLLAPSIBLE_CONTENT_CLASS );
                parentBlockElement.addClass( COLLAPSIBLE_PARENT_CLASS );
            }


            function initAttributes() {
                isMobileOnly        = attrs.hasOwnProperty( 'mobileOnly' );
                $scope.isCollapsed  = attrs.hasOwnProperty( 'collapsed' ) ? attrs[ 'collapsed' ] : $scope.isCollapsed;

                showMoreLabel = ( attrs.hasOwnProperty( 'showMoreLabel') ? attrs[ 'showMoreLabel' ] : DEFAULTS.SHOW_MORE_LABEL ) + " &dtrif;";
                showMoreTitle = attrs.hasOwnProperty( 'showMoreTitle') ? attrs[ 'showMoreTitle' ] : DEFAULTS.SHOW_MORE_TITLE;
                showMoreClass = attrs.hasOwnProperty( 'showMoreClass') ? attrs[ 'showMoreClass' ] : DEFAULTS.SHOW_MORE_CLASS;

                showLessLabel = ( attrs.hasOwnProperty( 'showLessLabel') ? attrs[ 'showLessLabel' ] : DEFAULTS.SHOW_LESS_LABEL ) + " &utrif;";
                showLessTitle = attrs.hasOwnProperty( 'showLessTitle') ? attrs[ 'showLessTitle' ] : DEFAULTS.SHOW_LESS_TITLE;
                showLessClass = attrs.hasOwnProperty( 'showLessClass') ? attrs[ 'showLessClass' ] : DEFAULTS.SHOW_LESS_CLASS;

                collapsingCondition = attrs.hasOwnProperty( 'collapsingCondition' ) ? attrs[ 'collapsingCondition' ] : DEFAULTS.COLLAPSING_CONDITION;

                minRows   = attrs.hasOwnProperty( 'minRows' ) ? attrs[ 'minRows' ] : DEFAULTS.MIN_ROWS;

                parentBlockElement = collapsibleBlockElement.parent();
            }


            function initTemplates() {
                controlsTemplate = '<div class="collapsible__control">\n'
                    + '<a ng-href="{{:: \'javascript:;\' | safeUrl }}" ng-class="isCollapsed ? \'' + ( showMoreClass ? showMoreClass : '' ) + '\' : \'' + showLessClass + '\'" title="{{ isCollapsed ? \'' + showMoreTitle + '\' : \'' + showLessTitle + '\'}}" role="presentation" ng-click="toggle()"> {{ isCollapsed ? "' + showMoreLabel + '" : "' + showLessLabel + '" }} </a>\n'
                    + '</div>\n';
            }


            function isMobile() {
                return $window.innerWidth <= CONFIG.UI.RESPONSIVE.MOBILE_LARGE_WIDTH;
            }


            function toggle() {
                $scope.isCollapsed = !$scope.isCollapsed;
                invalidate();
            }


            function invalidate() {
                if ( $scope.isCollapsed ) {
                    // Collapse
                    parentBlockElement.addClass( 'collapsed' );
                    parentBlockElement.removeClass( 'expanded' );

                    collapsibleBlockElement.height( minHeight );
                } else {
                    // Expand
                    parentBlockElement.addClass( 'expanded' );
                    parentBlockElement.removeClass( 'collapsed' );

                    collapsibleBlockElement.height( maxHeight );
                }
            }


        }



    }
})();
